import { render, staticRenderFns } from "./ProblemForm.vue?vue&type=template&id=c2fda51c&scoped=true&"
import script from "./ProblemForm.vue?vue&type=script&lang=js&"
export * from "./ProblemForm.vue?vue&type=script&lang=js&"
import style0 from "./TourMeta.scss?vue&type=style&index=0&id=c2fda51c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fda51c",
  null
  
)

export default component.exports